/*global google*/
/* eslint-disable */

import React from 'react'
import {message} from 'antd'
import {Redirect} from 'react-router-dom'
import http from '../../Component/Interceptor/Interseptor'
import {GoogleMap, Marker, withGoogleMap, withScriptjs} from 'react-google-maps'
import {MDBBreadcrumb, MDBBreadcrumbItem} from 'mdbreact'
import cookie from 'react-cookies'
import BASE_MANAGE from '../BaseComponent/BASEMANAGE'

const {compose, withProps} = require('recompose')

class EditProvince extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      provinceId: '',
      cityName: '',
      provinceName: '',
      latitude: '',
      longitude: '',
      provinces: [],
      redirect: false
    }
  }

  handleChange = (selectedOption) => {
    this.setState({selectedOption})
    this.setState({
      provinceValue: selectedOption.value
    })
    console.log(`Option selected:`, selectedOption)
  }

  renderRedirect = () => {
    if (this.state.redirect) {
      return <Redirect to="/Province" />
    }
  }

  componentDidMount() {
    let {provinceId} = this.props.match.params

    http
      .get(`public/base/type/get/province?provinceId=${provinceId}`, {})
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          let result = response.data.object
          this.setState({
            provinceId: result.provinceId,
            provinceName: result.name,
            latitude: result.latitude,
            longitude: result.longitude
          })
        }
        // alert(JSON.stringify(response.data))
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  submitForm(e) {
    e.preventDefault()
  }

  EditProvince() {
    let {provinceId} = this.props.match.params
    var name = document.getElementById('name').value
    var errorForm = false
    var nameError = false
    var provinceError = false
    var positionError = false
    if (name == '') {
      errorForm = true
      nameError = true
      message.error('نام استان را وارد کنید')
    } else {
      if (!nameError) {
        this.setState({
          error: 'none'
        })
      }
    }
    if (this.state.latitude == null && this.state.longitude == null) {
      errorForm = true
      positionError = true
      message.error('موقعیت استان را از روی نقشه تعیین کنید')
    } else {
      if (!positionError) {
        this.setState({error: ''})
      }
    }

    if (!errorForm) {
      const token = sessionStorage.getItem('accessToken')
      var data = {
        name: name,
        latitude: this.state.latitude,
        longitude: this.state.longitude,
        provinceId: provinceId
      }
      http
        .post(`${BASE_MANAGE.BASE_MANAGE_TYPE_EDIT_PROVINCE}`, data, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        })
        .then((response) => {
          if (response.data.error == null) {
            message.success('استان ویرایش شد.لطفا صبر کنید')
            this.setState({
              redirect: true
            })
            setInterval(() => {
              window.location.assign('/Province')
            }, 2000)
          } else {
            message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
          }
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    }
  }

  render() {
    const {selectedOption} = this.state
    const MapWithADrawingManager = compose(
      withProps({
        googleMapURL:
          'https://maps.googleapis.com/maps/api/js?key=AIzaSyAZt97TFAMPbJkQreQAb9KyRx3Qu7dOcxw&v=3.exp&libraries=geometry,drawing,places',
        loadingElement: <div style={{height: `100%`}} />,
        containerElement: <div style={{height: `300px`}} />,
        mapElement: <div style={{height: `100%`}} />
      }),
      withScriptjs,
      withGoogleMap
    )((props) => (
      <GoogleMap
        defaultCenter={new google.maps.LatLng(this.state.latitude, this.state.longitude)}
        defaultZoom={6}
        ref={(node) => (this.myMap = node)}
        onClick={(e) => {
          this.setState({
            latitude: e.latLng.lat(),
            longitude: e.latLng.lng()
          })
        }}
      >
        <Marker
          defaultPosition={{lat: this.state.latitude, lng: this.state.longitude}}
          ref={(node) => (this.marker = node)}
        />
      </GoogleMap>
    ))

    return (
      <div className="rtl">
        {/*<AdminMenu/>*/}
        <div className="wrapperIframe">
          <MDBBreadcrumb>
            <MDBBreadcrumbItem>بروزرسان</MDBBreadcrumbItem>
            <MDBBreadcrumbItem>لیست استان ها</MDBBreadcrumbItem>
            <MDBBreadcrumbItem active>ویرایش استان</MDBBreadcrumbItem>
          </MDBBreadcrumb>
          <MapWithADrawingManager />
          <form className="inlineForm" onSubmit={this.submitForm.bind(this)}>
            <figure>
              <label>نام استان : (الزامی)</label>
              <input
                type="text"
                defaultValue={this.state.provinceName}
                className="form-control"
                id="name"
                name="name"
              />
            </figure>
            <figure>
              <label className="hiddenLabel">نام شهر : (الزامی)</label>
              <button className="btn btn-primary form-control btn-sm" onClick={this.EditProvince.bind(this)}>
                ویرایش استان
              </button>
              {this.renderRedirect()}
            </figure>
          </form>
        </div>
      </div>
    )
  }
}

export default EditProvince
